export default "__VITE_ASSET__Nm4i6$ug__"